import {Api} from "../../../api/api.js";
import FileSaver from 'file-saver'

export const handleDownloadRaport = (uuid, setLoading, uri = '/oper/raporty/download') => {
    setLoading(true)
    Api.get(`${uri}/${uuid}`, {
        responseType: "blob",
    }).then((response) => {
        setLoading(false)
        const header = response.headers?.['content-disposition']
        let filename = header?.split(';')
            .find(n => n.includes("filename="))
            .replace("filename=", '')
            .replace(/"/g, '')
            .trim()

        const blob = new Blob([response.data])

        response.status === 200 && FileSaver.saveAs(blob, decodeURIComponent(filename))
        response.status === 200 && blob

        // && store.dispatch(addToast({
        //     type: "success",
        //     header: "Pobrano raport",
        //     body: `Pobrano raport - sprawdź folder pobranych plików`
        // }))
        response.status !== 200
        // && store.dispatch(addToast({
        //     type: "error",
        //     header: "Błąd pobierania raportu",
        //     body: `Wystąpił błąd podczas pobierania raportu`
        // }))
    })

}